import { TableCell, TableHead, TableRow } from '@/components/ui/table';
import type { CarryVestingStatus } from '@/types/carryFund';
import {
  MUTED_NUM_CELL,
  formatShare,
  formatUnits,
  poolShare,
  unvestedUnits,
} from '../funds/carryFundValues';
import { CarryVestingDaysCell } from './CarryVestingDaysCell';

export function CarryPositionHeads() {
  return (
    <TableRow>
      <TableHead>Name</TableHead>
      <TableHead className="text-right">Number</TableHead>
      <TableHead className="text-right">Share</TableHead>
      <TableHead className="text-right">Vested</TableHead>
      <TableHead className="text-right">Unvested</TableHead>
      <TableHead className="text-right">Days</TableHead>
    </TableRow>
  );
}

export function CarryPositionNameCell({
  name,
  sub,
}: {
  name: string;
  sub: string;
}) {
  return (
    <TableCell>
      <span className="font-medium">{name}</span>
      <span className="ml-2 text-xs text-muted-foreground">{sub}</span>
    </TableCell>
  );
}

interface CarryPositionShareCellsProps {
  units: number;
  totalCarryUnits: number;
}

export function CarryPositionShareCells({
  units,
  totalCarryUnits,
}: CarryPositionShareCellsProps) {
  return (
    <>
      <TableCell className="text-right">{formatUnits(units)}</TableCell>
      <TableCell className="text-right">
        {formatShare(poolShare(units, totalCarryUnits), 1)}
      </TableCell>
    </>
  );
}

interface CarryPositionVestingCellsProps {
  units: number;
  vestedUnits: number;
  vestingStatus: CarryVestingStatus;
  vestedDays: number | null;
  unvestedDays: number | null;
}

export function CarryPositionVestingCells({
  units,
  vestedUnits,
  vestingStatus,
  vestedDays,
  unvestedDays,
}: CarryPositionVestingCellsProps) {
  return (
    <>
      <TableCell className="text-right text-emerald-600 dark:text-emerald-400">
        {formatUnits(vestedUnits)}
      </TableCell>
      <TableCell className={MUTED_NUM_CELL}>
        {formatUnits(unvestedUnits({ units, vested_units: vestedUnits }))}
      </TableCell>
      <CarryVestingDaysCell
        vestingStatus={vestingStatus}
        vestedDays={vestedDays}
        unvestedDays={unvestedDays}
      />
    </>
  );
}
